import React, { Component } from 'react';
import { withRouter } from 'react-router';
import volunteerGroupService from './VolunteerGroupService';
import { Button } from 'reactstrap';

class VolunteerGroupDeletePlain extends Component {
	constructor(props) {
		super(props);
		this.state = { users: [], loading: true };

		const { match } = this.props;
		this.id = match.params.id;
	}

	componentDidMount() {

	}

	handleClickOk = () => {
		const { history } = this.props;

		(async () => {
			await volunteerGroupService.delete(this.id);
			history.push('/volunteergroups');
		})();
	}

	handleClickCancel = () => {
		const { history } = this.props;

		history.push('/volunteergroups');
	}

	render() {
		return (
			<div>
				<h2>Are you sure you want to delete volunteer group ?</h2>

				<button onClick={this.handleClickOk}>Yes</button>
				<button onClick={this.handleClickCancel}>No</button>
			</div>
		);
	}
}
export const VolunteerGroupDelete = withRouter(VolunteerGroupDeletePlain);